<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalClass]="modalClass"
    [modalHelpIndex]="modalHelpIndex" [isPrimaryBtnEnabled]="true" [primaryButtonLabel]="primaryButtonLabel"
    (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">

    <div class="modal-row">
        <div class="modal-row-column-auto group-label">
            <label requiredAsterisk for="project">Originating Project Name: </label>
        </div>
        <div class="modal-row-column-max description">
            <select class="modal-row-column-auto" [(ngModel)]="selectedProject"
                [attr.data-automation-id]="modalAutomationId + '-project-dropdown'" >
                <option *ngFor="let project of attachedProjects"> {{project.name}}
                </option>
            </select>
        </div>
    </div>
</res-base-modal>